import React from 'react';
import type { OkeyInfo } from '@shared/types';
import { TileComponent } from '../tiles/TileComponent';

interface OkeyIndicatorProps {
  okeyInfo: OkeyInfo | null;
}

export const OkeyIndicator = React.memo(function OkeyIndicator({ okeyInfo }: OkeyIndicatorProps) {
  if (!okeyInfo) {
    return (
      <div className="indicator-area">
        <span className="indicator-label">GÖSTERGE</span>
        <div className="tile tile-back" style={{ opacity: 0.4 }} />
        <span className="indicator-sublabel">—</span>
      </div>
    );
  }

  const { indicator, okey } = okeyInfo;
  const okeyLabel = `${okey.number === 1 ? 13 : okey.number - 1}+1=${okey.number}`;

  return (
    <div className="indicator-area">
      <span className="indicator-label">GÖSTERGE</span>
      <TileComponent tile={indicator} disabled />
      <span className="indicator-sublabel" title={`Okey: ${okey.color} ${okey.number}`}>
        Okey →{' '}
        <span style={{ fontWeight: 700, color: 'var(--gold-light)' }}>
          {okey.number}
        </span>
      </span>
    </div>
  );
});

export default OkeyIndicator;
